<template>
  <b-list-group>
    <b-list-group-item to="/user" class="" :class="{'active-route': currentRoute('/user')}">
      <b-icon icon="house-door" class="mr-2" />{{ $t('comp.thesidebar.ui.link.user') }}
    </b-list-group-item>
    <b-list-group-item to="/password/change" class="" :class="{'active-route': currentRoute('/password/change')}">
      <b-icon icon="lock" class="mr-2" />{{ $t('comp.thesidebar.ui.link.password_change') }}
    </b-list-group-item>
    <b-list-group-item to="/mfa/overview" class="" :class="{'active-route': currentRoute('/mfa/overview')}">
      <b-icon icon="shield-lock" class="mr-2" />{{ $t('comp.thesidebar.ui.link.mfa') }}
    </b-list-group-item>
    <b-list-group-item to="/email" class="" :class="{'active-route': currentRoute('/email')}">
      <b-icon icon="envelope" class="mr-2" />{{ $t('comp.thesidebar.ui.link.emails') }}
    </b-list-group-item>
    <b-list-group-item to="/unicard" class="" :class="{'active-route': currentRoute('/unicard')}">
      <b-icon icon="credit-card" class="mr-2" />{{ $t('comp.thesidebar.ui.link.unicard') }}
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { i18nMixin } from '@rrze/vue-bixins'

export default {
  name: 'TheSidebar',
  i18nCompName: 'thesidebar',
  i18n: {
    messages: {}
  },
  mixins: [i18nMixin],
  methods: {
    currentRoute (path) {
      return this.$route.fullPath.includes(path)
    }
  }
}
</script>

<style>
.active-route { background-color: #f8f9fa; }
</style>
